import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from '../locales/en/common.json';
import authEn from '../locales/en/auth.json';
import pagesEn from '../locales/en/pages.json';
import componentsEn from '../locales/en/components.json';

import commonAr from '../locales/ar/common.json';
import authAr from '../locales/ar/auth.json';
import pagesAr from '../locales/ar/pages.json';
import componentsAr from '../locales/ar/components.json';

export const RTL_LANGUAGES = ['ar'];

export function isRtlLanguage(lang: string): boolean {
  return RTL_LANGUAGES.includes(lang);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        auth: authEn,
        pages: pagesEn,
        components: componentsEn,
      },
      ar: {
        common: commonAr,
        auth: authAr,
        pages: pagesAr,
        components: componentsAr,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'pages', 'components'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
